module.exports = __webpack_public_path__ + "img/accessory_shirt_06.a96e54ac.svg";